const rootElement = document.documentElement;

/**
 * Обработчик загрузки блоков MainContentRBlock/MainContent2RBlock (см. LayoutUtils.java)
 */
export class LoadMainContentHandler {
    replaceRootModifiers(node: HTMLElement) {
        const removeModifiersString = node.dataset.modifiersRemove;
        const addModifiersString = node.dataset.modifiersAdd;

        if (removeModifiersString) {
            const removeModifiers = removeModifiersString.split(' ');
            rootElement.classList.remove(...removeModifiers);
        }
        if (addModifiersString) {
            const addModifiers = addModifiersString.split(' ');
            rootElement.classList.add(...addModifiers);
        }
    }

    activate(el: HTMLElement) {
        const { stateId } = el.dataset;

        this.replaceRootModifiers(el);

        OK.Tracer.log(`StateId has changed! New state: ${stateId}`);
        OK.Tracer.setErrorKey('stateId', stateId);
    }
}
